
import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

// Upload the PDF file
export const fileUpload = async (file, permitNamePrefix) => {
  const formDataToSend = new FormData();
  formDataToSend.append('uploadPDF', file![0]);

  const result = await httpRequest(
    'POST',
    `/uploadPDF/?permitName=${permitNamePrefix}`,
    formDataToSend,
    {
      'Content-Type': 'multipart/form-data'
    }
  );
  if (result?.status === 'success') {
    return {fileName: result.data.fileName, documentURL: result.data.downloadURL};
  }
  else if (result?.type === 'NETWORK_ERROR') {
  } else {
    toast.error(result?.message);
  }
};